import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { connectState } from '@examdojo/angular/util';
import { ColorSchemeService } from '@examdojo/browser/color-scheme';
import { IssueReportDialogService } from '@examdojo/core/debugging';
import { FeatureFlagService } from '@examdojo/core/feature-flag';
import { MatTooltipTruncateDirective } from '@examdojo/core/mat-tooltip-truncate';
import { ExamDojoFeatureFlag, ExamdojoFeatureFlags } from '@examdojo/models/feature-flag';
import { ProfileAvatarComponent, UserQuery } from '@examdojo/user';
import { TranslocoPipe } from '@jsverse/transloco';
import { RootUrlParts } from '../../app.model';
import {
  FEATURE_TO_FEATURE_FLAG,
  FEATURE_TO_ICON,
  FEATURE_TO_LABEL_KEY,
  Features,
} from '../../features/features.model';

@Component({
  selector: 'dojo-sidenav',
  imports: [
    RouterLink,
    TranslocoPipe,
    RouterLinkActive,
    ProfileAvatarComponent,
    MatTooltip,
    MatTooltipTruncateDirective,
  ],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent {
  constructor(
    private readonly userQuery: UserQuery,
    private readonly router: Router,
    private readonly issueReportDialogService: IssueReportDialogService,
    private readonly featureFlagService: FeatureFlagService<ExamdojoFeatureFlags>,
    private readonly colorSchemeService: ColorSchemeService,
  ) {}

  @Input() isCompact?: boolean;
  @Input() isMobile?: boolean;

  readonly featurePages = [
    Features.TopicPractice,
    Features.LearnHub,
    Features.Assessments,
    Features.QuestionBank,
    // Features.Leaderboards,
  ].map((feature) => ({
    route: feature,
    label: FEATURE_TO_LABEL_KEY[feature],
    icon: FEATURE_TO_ICON[feature],
    isVisible: FEATURE_TO_FEATURE_FLAG[feature] ? this.featureFlagService.get(FEATURE_TO_FEATURE_FLAG[feature]) : true,
  }));

  readonly state = connectState({
    user: this.userQuery.active$,
    darkMode: this.colorSchemeService.hasDarkMode$,
  });

  protected readonly RootUrlParts = RootUrlParts;

  navigateToProfile() {
    this.router.navigate([RootUrlParts.Settings]);
  }

  openIssueReportDialog() {
    if (!this.featureFlagService.get(ExamDojoFeatureFlag.IssueReport)) {
      return;
    }
    this.issueReportDialogService.openDialog();
  }
}
